/*========================================================================
* $Id: emailalert_preset.js 91712 2016-07-06 15:14:22Z daniel.eppensteiner $
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2014
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

define([
  "client/template",
  "i18n/i18n",
  "component!base",
  "client/views/list",
  "api/v2/search",
  "utils/browser",
  "utils/clone",
  "utils/dom",
  "utils/url",
  "utils/mustache",
  "utils/jsonpath",
  "utils/persistedsourceinfo",
  "model/persisted_collection",
  "service/stub",
  "client/application",
  "api/v2/common",
  "utils/localStorage",
  "backbone",
  "underscore",
  "jquery",
  "model/alertcenter",
  "api/v2/persisted",
  "service/channel",
  "service/channels",
  "api/v2/resources",
  "client/resourceinfo",
  "!!raw-loader!../mustache/template.mustache",
  "model/persisted_collection_application_extensions"
], function (
  Template,
  i18n,
  Base,
  ListView,
  Search,
  Browser,
  clone,
  dom,
  url,
  Mustache,
  JSONPath,
  PersistedSourceInfo,
  PersistedCollection,
  Stub,
  Application,
  Common,
  localStorage,
  Backbone,
  _,
  $,
  AlertModels,
  Persisted,
  Channel,
  Channels,
  Resources,
  ResourceInfo,
  DEFAULT_TEMPLATE
) {

  var EmailAlertPreset = Template.extend({

    initialize: function() {
      this.initializationPromise = new Channel.DeferredCallFinished();
      Template.prototype.initialize.apply(this, _.toArray(arguments));

      this.getEmailAlertPresets();
    },

    getEmailAlertPresets: function () {
      var that = this;
      this.application.models.emailAlerts.getSchemaByPath(["emailalert"], this.application, function (response) {
        var property_definitions = response && response.property_definitions;
        var referenced_notification = _.find(property_definitions, function (property) {
          return property.key == "referenced_notification";
        });
        
        var reference_target_collection_path = referenced_notification && referenced_notification.reference_target_collection_path;
        if (reference_target_collection_path) {
          that.application.models.emailAlerts.getAlertPresets({path: reference_target_collection_path, application: that.application}, function () {
            that.initializationPromise.triggerDone();
          }, function() {
            that.initializationPromise.triggerDone();
          });
        } else {
          that.initializationPromise.triggerDone();
        }

      }, function() {
        that.initializationPromise.triggerDone();
      }); //callback, errback?
    },

    hasContent: function () {
      return true;
    },

    model: function(options) {
      return this.application.models.emailAlerts.get("alert_presets");
    },

    createView: function(options) {

      options = _.extend(
       this.attributeModel.getCamelCase(),
       options,
       {
         elementTemplate: this.node.children[0].template
       }
       );
      delete options.node;

      return Template.prototype.createView.apply(this, [options]);
    },

    schema: new Template.Schema({
      attributes: {
     }
   })

  });

  var MyListView = ListView.extend({
    setModel: function() {
      ListView.prototype.setModel.apply(this, arguments);
      if (this.model) this.listenTo(this.model, "change", this.addAll);

    },

    addAll: function(collection, options) {
      if (!collection || !collection.models) return
      for (var i = 0; i < collection.models.length; i++) {
        this.addOne(collection.models[i], collection, options);
      }
    }
  });

  MyListView.EntryView = ListView.EntryView.extend({
    createChildView: function (options) {
      options = _.extend(
        {
          modelType: "AlertModel"
        },
        options
      );
      return this.options.childViewConstructor.createView(options);
    }
  });

  EmailAlertPreset.View = Base.extend({

    defaultOptions: {
      titleTagName: "h2"
    },

    initialize: function () {
      $(this.el).addClass("notification_alerts");
      this.titleEl = this.make(this.options.titleTagName || this.defaultOptions.titleTagName, {
           "class": this.options.titleClassName,
           "id": "globalAlerts-title-" + this.cid
         }, i18n(this.options.title) || i18n("globalAlerts"));

      $(this.el).prepend(this.titleEl);

      if (!this.options.title) {
        $(this.titleEl).attr("data-i18n", "globalAlerts");
      }

      this.list = new MyListView(_.extend({
        childViewConstructor: this.options.elementTemplate
      }, this.defaultOptions, this.options, {
        el: null,
        model: this.model
      }));

      this.appendChild(this.list.render().el);  

      this.options.application.editGlobalAlert = this.options.application.editGlobalAlert || function (options) {
        options.event.preventDefault();
        options.editSubscribed = true;
        this.alertsStackManager(options);
      }; 

      this.options.application.subscribeGlobalAlert = this.options.application.subscribeGlobalAlert || function (options) {
        options.event.preventDefault();
        if(window.innerWidth <= 991 && !options.forceOpen) {
          this.toggleOpen(options);
          return;
        }
        options.subscribe = true;
        this.alertsStackManager(options);
      };

      this.options.application.shareGlobalAlert = this.options.application.shareGlobalAlert || function (options) {
        $(options.eventTarget.parentElement).toggleClass("active");
        var input = $(options.eventTarget.parentElement).find("input");
        input.focus();
        input.select();

        var toggleElement = function(e) {
          var isChild = $('.mb-alert-action-container').find(e.target).length;
          if ( !isChild ){
            $('body').unbind("click", toggleElement);
            $('.group-headline-edit').removeClass("active");
          }
        }
        $('body').on("click", toggleElement);
      };

      this.options.application.removeGlobalAlert = this.options.application.removeGlobalAlert || function (options) {
        var model = options.model;
        model.set("enabled", "false");
        model.set("hidden", "true")
        model.save(null, {
          success: function (model, response) {},
          error: function (model, response) {
            //TODO?
            //model.set("enabled", "true");
            //model.set("hidden", "false");
          }
        });

      };
    },

    remove: function (options) {
      //TODO what else?
      Backbone.View.prototype.remove.apply(this, arguments);
    }

  });

  EmailAlertPreset.DEFAULT_TEMPLATE = DEFAULT_TEMPLATE && DEFAULT_TEMPLATE.default;
  
  return EmailAlertPreset;
});
